import React from "react";
import { PSC_TOTAL_MAX, ScreenerResult } from "./scoring";

type ScoreBandProps = {
  readonly result: ScreenerResult;
};

export default function ScoreBand({ result }: ScoreBandProps) {
  return (
    <div className={`screener-band screener-band--${result.band}`}>
      <p className="screener-band__score">
        <span className="screener-band__total">{result.total}</span>
        <span className="screener-band__max"> / {PSC_TOTAL_MAX}</span>
      </p>
      <h2 className="screener-band__headline">{result.headline}</h2>
      <p className="screener-band__body">{result.body}</p>
    </div>
  );
}
